import axios from 'axios';
import { checkinModule } from './CommonFun';
export const LocalUrl = process.env.REACT_APP_API_URL;

// export const sendingBpUrl = process.env.REACT_APP_API_URL_FOR_SENDING_BP;
// export const sendingBpCredentialsUN = process.env.REACT_APP_CREDENTIALS_BP_USERNAME;
// export const sendingBpCredentialsPW = process.env.REACT_APP_CREDENTIALS_BP_PASSWORD;

export function fncLoginApi(username, password) {

  document.getElementById("showAndHideSpinner").style.display = "block";

  return axios({
    method: "post",
    url: LocalUrl + "Token/Login",
    data: {
      "AirlineCode": process.env.REACT_APP_AirlineCode,
      "UserName": username,
      "Password": password
    }
  })
    .then((response) => {
      ;
      return response;
    })
    .catch((error) => {

      return error.response;
    })
}


export function fncStationsApi() {
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    // headers: {'Authorization': 'Bearer '+Token},
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Resource/Station",
    data: ""
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })
}


export function FncSearchApi(st_date, origin, destination, firstName, lastName, RecordLocator, IsDisregard, carriercode, flightnum, opsuffix, IsQuickSearch, CurrentDateTime, Location) {
  document.getElementById("showAndHideSpinner").style.display = "block";
     
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    // headers: {'Authorization': 'Bearer '+Token},
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Flight/search",
    data: {
      // "signature":Token,
      "DepartureDate": st_date,
      "CarrierCode": carriercode,
      "Origin": origin,
      "Destination": destination,
      "FlightNumber": flightnum,
      "RecordLocator": RecordLocator,
      "IsDisregard": IsDisregard,
      "FirstName": firstName,
      "LastName": lastName,
      "IsQuickSearch": IsQuickSearch,
      "CurrentDateTime": CurrentDateTime,
      "Location": Location
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })
}

export function fncCallSeatMapApi(vsegmentKey, mode) {
     
  document.getElementById("showAndHideSpinner").style.display = "block";
  let data = {};
  if (mode === checkinModule) {
    data.segmentKey = vsegmentKey;
  } else {
    data.journeyKey = vsegmentKey;
  }
  debugger
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Seat/seatmap",
    data
  })
    .then((response) => {
         
      document.getElementById("showAndHideSpinner").style.display = "block";
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncSeatIdentificationApi(reqParam) {
  document.getElementById("showAndHideSpinner").style.display = "block";

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Flight/SeatIdentification",
    data: reqParam
  })
    .then((response) => {
         
      document.getElementById("showAndHideSpinner").style.display = "block";
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })
}

export function fncAutoAssignPassengerSeats(IsAutoAssign, AutoAssignSeatRequest, from) {

  document.getElementById("showAndHideSpinner").style.display = "block";

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Seat/assignseat",
    data: {
      "IsAutoAssign": IsAutoAssign,
      AutoAssignSeatRequest,
      Mode: from
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}


export function fncUnAssignPassengerSeats(UnassignSeats) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Seat/unassignseat",
    data: UnassignSeats
  })
    .then((response) => {

      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncAssignPassengerSeats(apiBody) {
  debugger
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Seat/assignseat",
    data: apiBody
  })
    .then((response) => {

      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}


export function fncGetBookingFromState() {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Booking/GetBookingFromState",
    data: {
      // "Signature" : Token
    }
  })
    .then((response) => {

      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncAddBaggage(baggages) {

  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/AddBaggage",
    data: baggages
  })
    .then((response) => {

      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })
}

export function fncAddInfant(infants) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Passenger/AddInfant",
    data: infants
  })
  .then((response) => {
    return response;
  })
  .catch((error) => {
    console.log(error);
    return error.response;
  })
}

export function fncRemoveBaggage(removebaggages) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/RemoveBaggage",
    data: removebaggages
  })
    .then((response) => {

      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}


export function fncFEE() {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Resource/Fee",
    data: {
      // "Signature" : Token
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncSSR() {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Resource/SSR",
    data: {
      // "Signature" : Token
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncAddFEE(addFee) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/AddFee",
    data: addFee
  })
    .then((response) => {


      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}


export function fncRemoveFEE(removeFee) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/RemoveFee",
    data: removeFee
  })
    .then((response) => {


      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncAddSSR(addSSR) {
     
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/AddSSR",
    data: addSSR
  })
    .then((response) => {


      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncGetPayment() {


  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Resource/PaymentMethod",
    data: {
      // "Signature":Token
    }
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncAddPaymentApi(addPayment) {

  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/AddPayment",
    data: addPayment
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncRemovePayment(payKey) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/RemovePayment",
    data: [{
      // "signature":Token,
      "PaymentKey": payKey
    }]
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncCheckInPassengerApi(checkInPassengerDetails) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/CheckIn",
    data: checkInPassengerDetails
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncUndoCheckInPassengerApi(UndocheckInPassengerDetails) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/UndoCheckIn",
    data: UndocheckInPassengerDetails
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncSaveChangesApi() {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Booking/BookingCommit",
    data: {
      // "Signature" : Token
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}


export function fncGetBoardingPassApi(data) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Booking/GetBoardingPass",
    data: data
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}


export function fncGetFeePriceApi(data) {
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/GetFeePrice",
    data: data
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}




export function fncGetSSRPriceApi(data) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/GetSSRAvailability",
    data: data
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}

export function fncOverrideFee(data) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/OverrideFee",
    data: data
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      console.log(error);
      return error.response;
    })

}


export function fncLogoutApi() {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "Token/Logout",
    data: ""
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      console.log('e in fncLogoutApi', error);
      return error.response;
    })

}


export function fncCheckInBaggageApi(data) {

  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/CheckInBaggage",
    data: data
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })

}

export function fncGetConvinienceFee(data) {

  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl + "FlightOperation/GetPaymentFee",
    data: data
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })

}
export function fncKeepAliveSession() {

  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Token/KeepAlive",
    data: ""
  })
    .then((response) => {



      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })

}


export function fncUpdateBaggage(updateBags) {

  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"FlightOperation/UpdateBaggage",
    data: updateBags
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })

}

export function fncUpdatePassengerInfo(updatePax) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Passenger/EditPassengerInfo",
    data: updatePax
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })

}

export function fncGetAllComments() {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Booking/GetAllComments",
    data: {}
  })
  .then((response) => {
    return response;
  })
  .catch((error) => {
    // console.log(error);
    return error.response;
  });
}

export function fncAddComment(comment) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Booking/AddComment",
    data: comment
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncConfirmBaggageApi(data) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+ "Booking/ConfirmBaggage",
    data
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}


export function fncGetPnrHistory(bookingKey) {

  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Booking/GetPNRHistory",
    data: {
      BookingKey: bookingKey
    }
    
  })
  .then((response) => {
    return response;
  })
  .catch((error) => {
    // console.log(error);
    return error.response;
  });
}

export function fncAddPassengerContactDetails(address) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Passenger/AddPassengerAddress",
    data: address
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncEditPassengerContactDetails(address) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");

  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Passenger/EditPassengerAddress",
    data: address
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncSendSMS(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  // const Token = localStorage.getItem("LoginToken");
  // const credentials = btoa('WEBDCSApp:Web@#DC$123');bpapi/api/WebDCS/SendSMS
  // 'https://sgservice.spicejet.com/BoardingPassAPI/api/boardingpasswebdcs', request, { auth: {
  //   username: 'WEBDCSApp',
  //   password: 'Web@#DC$123'
  //   }}
  return axios.post(`${process.env.REACT_APP_API_URL_FOR_SENDING_BP}WebDCS/SendSMS`,
  request,
  {
    auth: {
      username: process.env.REACT_APP_CREDENTIALS_BP_USERNAME,
      password: process.env.REACT_APP_CREDENTIALS_BP_PASSWORD
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncSendWhatsapp(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  // const Token = localStorage.getItem("LoginToken");
  // const credentials = btoa('WEBDCSApp:Web@#DC$123');bpapi/api/WebDCS/SendSMS
  // 'https://sgservice.spicejet.com/BoardingPassAPI/api/boardingpasswebdcs', request, { auth: {
  //   username: 'WEBDCSApp',
  //   password: 'Web@#DC$123'
  //   }}
  return axios.post(`${process.env.REACT_APP_API_URL_FOR_SENDING_BP}WebDCS/SendWhatsApp`,
  request,
  {
    auth: {
      username: process.env.REACT_APP_CREDENTIALS_BP_USERNAME,
      password: process.env.REACT_APP_CREDENTIALS_BP_PASSWORD
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncSendEmail(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  // const Token = localStorage.getItem("LoginToken");
  // const credentials = btoa('WEBDCSApp:Web@#DC$123');bpapi/api/WebDCS/SendSMS
  // 'https://sgservice.spicejet.com/BoardingPassAPI/api/boardingpasswebdcs', request, { auth: {
  //   username: 'WEBDCSApp',
  //   password: 'Web@#DC$123'
  //   }}
  return axios.post(`${process.env.REACT_APP_API_URL_FOR_SENDING_BP}BP/GETBP`,
  request,
  {
    auth: {
      username: process.env.REACT_APP_CREDENTIALS_BP_USERNAME,
      password: process.env.REACT_APP_CREDENTIALS_BP_PASSWORD
    }
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncMBPDetails(request) {
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Booking/GetMobileBoardingPassDetails",
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncManifestDetails(request) {
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Flight/ManifestCounts",
    data: request
  })
    .then((response) => {
      // console.log('response', response)
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncFlightSearchForBoarding(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+"Flight/SearchFlight",
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncLoadFlightManifestDataForBoarding(request, intervalCall = false) {
  if (!intervalCall) {
    document.getElementById("showAndHideSpinner").style.display = "block";
  }
  
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "get",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Flight/GetManifestByLegKey/${request}`,
    // data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncGetTripStatus(request, intervalCall = false, notificationCall = false) {
  if (!intervalCall) {
    document.getElementById("showAndHideSpinner").style.display = "block";
  }
  const Token = localStorage.getItem("LoginToken");
  let apiurl = LocalUrl+`Flight/GetTripStatus/${request}/${notificationCall}`
  return axios({
    method: "get",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: apiurl,
    // data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncBoardPassengers(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`FlightOperation/BoardPassenger`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncUnBoardPassengers(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "delete",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`FlightOperation/UnboardPassenger`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncBlockSeat(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Seat/BlockSeats`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncUnBlockSeat(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "delete",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Seat/UnblockSeats`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncCloseFlight(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "put",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Flight/closeLeg/${request}?bypassCheckinRestrictions=false`
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      document.getElementById("showAndHideSpinner").style.display = "none";
      return error.response;
    })
}

export function fncClosePendingFlight(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "put",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Flight/closePendingLeg/${request}`
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      document.getElementById("showAndHideSpinner").style.display = "none";
      return error.response;
    })
}

export function fncOpenFlight(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "put",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Flight/openLeg/${request}?bypassCheckinRestrictions=false`
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncAddPassengerDocuments(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`passenger/AddPassengerDocuments`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncUpdatePassengerDocuments(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`passenger/UpdatePassengerDocuments`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncGetPassengerDocuments(request, intervalCall = false) {
  if (!intervalCall) {
    document.getElementById("showAndHideSpinner").style.display = "block";
  }
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "get",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`passenger/GetPassengerDocuments?passengerKey=${request.passengerKey}&&isInfant=${request.hasInfant}`,
    // data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncGetPassengerDocumentByKey(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`passenger/GetPassengerDocumentByKey`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncDeleteTravelDocument(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`passenger/DeleteTravelDocument`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncChangeBoardingGateNumber(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Flight/GateChange`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncGetStationTime(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  return axios({
    method: "get",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Resource/StationTime/${request}`
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncGetAllFlyBigSchedules() {
  // document.getElementById("showAndHideSpinner").style.display = "block";
  return axios.get(`${process.env.REACT_APP_API_URL_FOR_FLYBIG}Schedule/GetAllFlyBigSchedules`,
  {
    auth: {
      username: process.env.REACT_APP_CREDENTIALS_FOR_FLYBIG_USERNAME, // 'SGFlyBigAdmin', //
      password: process.env.REACT_APP_CREDENTIALS_FOR_FLYBIG_PASSWORD // 'Spice#34@88' //
    }
  })
    .then((response) => {
      debugger
      return response;
    })
    .catch((error) => {
      // console.log(error);
      return error.response;
    })
}

export function fncLogJSPMPrint(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  const Token = localStorage.getItem("LoginToken");
  
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + Token },
    url: LocalUrl+`Resouce/Logs`,
    data: JSON.stringify(request)
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncSitaFlexGetTokenOrStatus(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json'},
    url: LocalUrl+`SITAFlex/Device`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}

export function fncSitaFlexPrintCall(request) {
  document.getElementById("showAndHideSpinner").style.display = "block";
  return axios({
    method: "post",
    headers: { 'Content-Type': 'application/json'},
    url: LocalUrl+`SITAFlex/Print`,
    data: request
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    })
}
